import {
  Typography,
  Form,
  message,
  Row,
  Col,
  Input,
  Button,
  Tooltip,
} from "antd";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import "react-phone-number-input/style.css";
import {
  resendOtpByEmailAction,
  updateOtpByEmailAction,
} from "../store/action/admin/authActions";
import AdminSignupPageCard from "./Components/Onboarding/adminSignupPageCard";
import { themeAction } from "../store/action/admin/themeActions";
import { langaugeTanslatorAction } from "../store/action/admin/languageTranslatorActions";
import { css } from "@emotion/css";
import { serviceLinks } from "./Components/dashboard";
// import { getFcmToken } from "../shared-components/push-notification";

function EmailOTPCard() {
  const { Title } = Typography;

  const router = useNavigate();

  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const updateOtpByEmailList = useSelector(
    (state) => state.updateOtpByEmailList
  );
  const { updateOtpByEmailLoading, updateOtpByEmailError } =
    updateOtpByEmailList;

  const sharedLogin = useSelector((state) => state.sharedLogin);
  const { sharedUserInfo } = sharedLogin;

  const [otp, setOtp] = useState(Array(6).fill(""));
  const refs = useRef([]);
  const handleOTPChange = (index) => (e) => {
    const { value } = e.target;
    const onlyNumbersPattern = new RegExp("^[0-9]+$");
    if (onlyNumbersPattern.test(value) || value === "") {
      setOtp((prevOTP) => {
        const newOTP = [...prevOTP];
        newOTP[index] = value;
        return newOTP;
      });

      if (value !== "") {
        if (index < 5) {
          refs.current[index + 1].focus();
        } else {
          refs.current[index].blur();
        }
      } else if (index > 0) {
        refs.current[index - 1].focus();
      }
    }
  };

  const onClicked = async () => {
    try {
      const email = sessionStorage.getItem("email");
      const data = {
        email,
      };
      await dispatch(resendOtpByEmailAction(data));
      message.success("OTP Send Successfully");
    } catch (error) {
      message.error("Try it again!", error);
    }
  };

  const queryParams = new URLSearchParams(window.location.search);
  const redirect_back = queryParams.get("redirect_back"); // Retrieves the "redirect_back" parameter

  const handleSubmit = async () => {
    try {
      const email = sessionStorage.getItem("email");
      const code = otp?.join("");

      if (!otp) {
        return message.error("Please enter OTP before submitting.");
      }
      // const fcmToken = await getFcmToken();
      let data = {
        otp: code,
        email,
        fcmToken: "",
      };
      const payload = await dispatch(updateOtpByEmailAction(data));
      // await dispatch(themeAction(false, true));
      if (
        payload?.isOnTrack ||
        payload?.isOnTrack === true ||
        payload?.isOnTrack === "true"
      ) {
        window.location.href = process.env.REACT_APP_FE_ONTRACK_URL;
      }
      if (redirect_back) {
        const app = serviceLinks(payload).find(
          (app) => app.name === redirect_back
        );
        if (app) {
          window.location.href = app.href;
        }
      } else {
        if (payload?.defaultApp) {
          const app = serviceLinks(payload).find(
            (app) => app.name === payload?.defaultApp
          );
          if (app) {
            window.location.href = app.href;
          }
        }
      }
      const themeData = await dispatch(themeAction(false, true));
      await dispatch(langaugeTanslatorAction(themeData?.language || "en"));
      sessionStorage.removeItem("email");
      form.resetFields();
    } catch (error) {
      message.error("Try it again! n", error);
    }
  };

  useEffect(() => {
    if (sharedUserInfo && sharedUserInfo?.payload) {
      if (
        sharedUserInfo &&
        sharedUserInfo?.payload?.email &&
        sharedUserInfo?.payload?.type === "Kiosk" &&
        sharedUserInfo?.payload?.emailVerification === true
      ) {
        if (sharedUserInfo?.empCompanies.length !== 0) {
          router(`/kiosk/qr-code`, { replace: true });
        }
      } else if (
        sharedUserInfo &&
        sharedUserInfo?.payload?.email &&
        sharedUserInfo?.payload?.type === "user" &&
        sharedUserInfo?.payload?.emailVerification === true
      ) {
        if (
          sharedUserInfo?.empCompanies.length === 0 ||
          sharedUserInfo?.empCompanies.length > 1
        ) {
          router("/user/company/", { replace: true });
        } else {
          router(`/user/dashboard/`, { replace: true });
        }
      } else if (
        sharedUserInfo &&
        sharedUserInfo?.payload?.email &&
        sharedUserInfo?.payload?.type === "admin"
      ) {
        if (
          sharedUserInfo?.payload?.company &&
          sharedUserInfo?.payload?.planSub
        ) {
          router(`/admin/dashboard/`, { replace: true });
        } else {
          if (sharedUserInfo?.payload?.company) {
            router("/admin/onboarding-wizard/organization-trial");
          } else {
            router("/admin/company-setup");
          }
        }
      } else if (
        sharedUserInfo &&
        sharedUserInfo?.payload?.email &&
        sharedUserInfo?.payload?.emailVerification === true
      ) {
        router(`/manager/dashboard/`, {
          replace: true,
        });
      }
    }
  }, [sharedUserInfo]);
  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text/plain");
    const otpArray = pastedData
      .slice(0, 6)
      .split("")
      .map((char) => (isNaN(parseInt(char, 10)) ? "" : char));
    setOtp(otpArray.concat(Array(6 - otpArray.length).fill("")));
  };

  const handleBackspace = (index) => (e) => {
    if (e.key === "Backspace" && otp[index] === "") {
      e.preventDefault(); // Prevent default backspace behavior
      if (index > 0) {
        setOtp((prevOTP) => {
          const newOTP = [...prevOTP];
          newOTP[index - 1] = "";
          return newOTP;
        });
        refs.current[index - 1].focus();
      }
    }
  };

  const otpStyle = {
    minHeight: "90vh",
    borderRadius: "32px",
    display: "flex",
    justifyContent: "center",
    /* flex-direction: column; */
    alignItems: "center",
    margin: "20px 0",
  };
  const twoColors = {
    "0%": "#f47e63",
    "100%": "#f47e63",
  };
  const [progress, setProgress] = useState(100);
  const duration = 300000; // 5 minutes in milliseconds
  const step = 0.01; // progress step size

  const [timeRemaining, setTimeRemaining] = useState(duration);

  useEffect(() => {
    startTimer();

    // Clean up interval
    return () => clearInterval(intervalRef.current);
  }, []);

  const intervalRef = useRef(null);

  const startTimer = () => {
    clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      setProgress((prevProgress) => {
        if (prevProgress > 0) {
          return prevProgress - 100 / (duration / (1000 * step));
        }
        clearInterval(intervalRef.current);
        return prevProgress;
      });
      setTimeRemaining((prevTime) => {
        if (prevTime > 0) {
          return prevTime - 1000 * step;
        }
        return 0;
      });
    }, 1000 * step); // Update progress every `step` seconds
  };

  const formatTime = (milliseconds) => {
    const totalSeconds = Math.floor(milliseconds / 1000);
    const minutes = String(Math.floor(totalSeconds / 60)).padStart(2, "0");
    const seconds = String(totalSeconds % 60).padStart(2, "0");
    return `${minutes}:${seconds}`;
  };

  return (
    <AdminSignupPageCard styled={otpStyle}>
      <Row
        style={{
          display: "flex",
          justifyContent: "center",
          // margin: "0 250px",
        }}>
        <Col span={24} style={{ marginBottom: "20px" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              gap: "5px",
            }}>
            <Title>Verify your Email Address</Title>
            <p>Please enter 6-digit verification code sent:</p>
          </div>
        </Col>

        {/* input */}
        <Col span={24} style={{ marginBottom: "20px" }}>
          <Form
            name="normal_login"
            className="login-form"
            layout="vertical"
            autoComplete="on"
            initialValues={{
              remember: true,
            }}
            onFinish={handleSubmit}>
            <Form.Item
              noStyle
              name="otp"
              rules={[
                {
                  required: true,
                  message: "Enter the correct OTP",
                },
              ]}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  // gap: "25px",
                }}>
                {otp.map((digit, index) => (
                  <Input
                    // placeholder="0"
                    key={index}
                    maxLength={1}
                    value={digit}
                    onChange={handleOTPChange(index)}
                    onPaste={handlePaste}
                    onKeyDown={handleBackspace(index)}
                    style={{
                      border: "none",
                      borderRadius: "0px",
                      borderBottom: "1px solid black",
                      width: "50px",
                      height: "50px",
                      marginRight: "10px",
                      textAlign: "center",
                    }}
                    ref={(el) => (refs.current[index] = el)}
                  />
                ))}
              </div>
            </Form.Item>
          </Form>
        </Col>

        {/* submit button */}
        <Col
          span={20}
          style={{
            width: "100%",
            gap: "10px",
            marginBottom: "20px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}>
          {" "}
          {/* error */}
          {updateOtpByEmailError && (
            <p style={{ color: "red" }}>{updateOtpByEmailError}</p>
          )}
          {/* <Progress
            strokeColor={twoColors}
            percent={progress}
            showInfo={false}
            size="small"
          /> */}
          <Form.Item
            style={{
              width: "100%",
            }}>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                onClick={handleSubmit}
                type="primary"
                htmlType={"submit"}
                loading={updateOtpByEmailLoading}
                className={css`
                  width: 60%;
                  height: 45px;
                `}>
                Login
              </Button>
            </div>
          </Form.Item>
          {/* timer and resent otp */}
          {progress > 0 ? (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}>
              <Tooltip
                title={`Wait for the timer to run out before resending the OTP`}>
                <div>
                  <p
                    style={{
                      cursor: "default",
                      color: "rgb(0 0 0 / 40%)",
                    }}>
                    Resend in
                  </p>{" "}
                </div>
              </Tooltip>
              <div>
                <p>{formatTime(timeRemaining)}</p>
              </div>
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}>
              <div>
                <p
                  onClick={onClicked}
                  style={{
                    cursor: "pointer",
                    color: "rgba(0, 0, 0, 0.85)",
                  }}>
                  Resend
                </p>
              </div>
              <div>{/* <p>{formatTime(timeRemaining)}</p> */}</div>
            </div>
          )}
        </Col>
      </Row>
    </AdminSignupPageCard>
  );
}

export default EmailOTPCard;
